// extracted by mini-css-extract-plugin
export default {"imageIcon":"FloatingButton_imageIcon__Hu6CB","shake":"FloatingButton_shake__9dOJb"};